import styled from 'styled-components';
import { PolarisBreakPoint } from '@/constants/enum';

export const StyledFulfillmentPerformance = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .summary-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .summary-card {
    display: flex;
    flex-direction: column;
    min-height: 100px;
  }

  .card-wrapper {
    position: relative;

    .Polaris-ShadowBevel {
      height: 100%;
    }

    &.locked {
      user-select: none;
      pointer-events: none;
    }

    &.locked::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(2px);
      border-radius: var(--p-border-radius-400);
      pointer-events: none;
      z-index: 1;
    }
  }
`;

export const TimelineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 0;
  position: relative;

  @media (max-width: ${PolarisBreakPoint.MD}) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const TimelineStage = styled.div<{ $isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  align-self: stretch;

  @media (max-width: ${PolarisBreakPoint.MD}) {
    width: 100%;
  }
`;

export const IconCircle = styled.div<{ $bgColor: string }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props) => props.$bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StageContent = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;

  @media (max-width: ${PolarisBreakPoint.MD}) {
    & {
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    & p {
      position: absolute;
      font-size: 0.75rem;
    }

    & p:nth-child(1) {
      right: 14px;
    }

    & p:nth-child(3) {
      left: 14px;
    }
  }
`;

export const Arrow = styled.div`
  position: relative;
  width: 100%;
  color: #c9cccf;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    border-top: 1px dashed currentColor;
  }

  &::after {
    content: '';
    position: absolute;
    right: -2px;
    top: -4px;
    border: dashed currentColor;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  @media (max-width: ${PolarisBreakPoint.MD}) {
    height: 4rem;

    &::before {
      width: 0;
      height: 100%;
      border-top: none;
      border-left: 1px dashed currentColor;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }

    &::after {
      top: auto;
      bottom: -2px;
      left: 50%;
      right: auto;
      transform: translateX(-50%) rotate(45deg);
    }
  }
`;

export const StageLabel = styled.div`
  font-size: 0.75rem;
  text-align: center;
  max-width: 100px;

  @media (max-width: ${PolarisBreakPoint.MD}) {
    text-align: center;
    max-width: fit-content;
  }
`;

export const TotalBar = styled.div``;

export const TotalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const TotalArrow = styled.div`
  position: relative;
  width: 100%;
  color: #c9cccf;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    border-top: 1px dashed currentColor;
  }

  &::after {
    content: '';
    position: absolute;
    right: -2px;
    top: -4px;
    border: dashed currentColor;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
`;
